import React from 'react';
import { CustomInput, FormFeedback, FormGroup } from 'reactstrap';
import { Label } from './Forms';
import clsx from 'clsx';

const Switch = ({
	className,
	id,
	name,
	caption,
	onClick,
	checked,
	disabled,
	isRequired,
	errors,
	defaultChecked,
	finado
}) => {
	return (
		<FormGroup>
			{caption && (
				<>
					<Label isRequired={isRequired}>{caption}</Label>
					<br />
				</>
			)}
			<CustomInput
				className={clsx(
					finado ? 'custom-control-finado' : 'custom-control-primary',
					className
				)}
				type="switch"
				id={id}
				name={name}
				onChange={onClick}
				checked={checked}
				disabled={disabled}
				defaultChecked={defaultChecked}
				inline
			/>
			{errors && <FormFeedback>{errors}</FormFeedback>}
		</FormGroup>
	);
};

export default Switch;
